import gql from 'graphql-tag'

/**
 * Derives one backlight colour per slide from the deck currently in the editor's
 * memory. Read-only: the CMS applies the result through its own reducer, so the
 * run stays undoable and never races the editor's save.
 *
 * `slides` and `config` are sent as JSON *objects* — the service maps
 * `Object.entries` over the slides it is handed and wants a `Record<slideId, Slide>`.
 * Do not stringify them the way the presentation save path does.
 *
 * Every slide sent comes back, in the order sent. `color` is lowercase `#rrggbb`
 * or null when nothing chromatic survived; `skipped` is true when at least one
 * element that could have contributed colour was not accounted for.
 */
export const GET_SLIDE_BACKLIGHT_COLORS_Q = gql`
  query GetSlideBacklightColorsQuery($slides: JSON!, $config: JSON!) {
    slideBacklightColors(slides: $slides, config: $config) {
      slideId
      color
      skipped
    }
  }
`
